import { ref, readonly } from 'vue'
import { cloneDeep } from 'lodash'

// 创建单例状态
const state = ref({
  carLevelFlag: true,
  cityCode: null,
  cityName: null,
  brandId: null,
  seriesId: null,
  modelId: null,
  operationType: null,
  enterType: null,
  setupSteps: null,
  storeIds: [], // 新增 storeIds 字段
})

export function useEditFormState() {
  // 更新单个字段
  const updateField = (key, value) => {
    state.value[key] = cloneDeep(value)
  }

  // 批量更新字段
  const updateFields = (data) => {
    if (!data) return
    Object.entries(data).forEach(([key, value]) => {
      if (key in state.value) {
        state.value[key] = cloneDeep(value)
      }
    })
  }

  // 重置状态
  const resetState = () => {
    Object.assign(state.value, {
      carLevelFlag: true,
      cityCode: null,
      cityName: null,
      brandId: null,
      seriesId: null,
      modelId: null,
      operationType: null,
      enterType: null,
      storeIds: [], // 确保重置时也包含 storeIds
    })
  }

  return {
    // 只读状态，防止直接修改
    state: readonly(state),

    // 更新方法
    updateField,
    updateFields,
    resetState,

    // 便捷方法
    setCarLevelFlag: (flag) => updateField('carLevelFlag', flag),
    setOperationType: (type) => updateField('operationType', type),
    setCityCode: (code) => updateField('cityCode', code),
    setCityName: (name) => updateField('cityName', name),
    setModelId: (id) => updateField('modelId', id),
    setBrandId: (id) => updateField('brandId', id),
    setSeriesId: (id) => updateField('seriesId', id),
    setEnterType: (val) => updateField('enterType', val),
    setStoreIds: (ids) => updateField('storeIds', ids),
    setSetupSteps: (index) => updateField('setupSteps', index),
  }
}
